import { css } from 'styled-components';

import theme from '../';

const ROOT_VARIABLES = css`
  :root {
    --colors-black-light: ${theme.palette.lightBlack};
    --colors-brand: ${theme.palette.primaryBrand};
    --colors-brand-soft: ${theme.palette.primaryBrandSoft};
    --colors-brand-dark: ${theme.palette.primaryBrandDark};
    --colors-input-background: ${theme.palette.inputBackgroundColor};
    --colors-input-color: ${theme.palette.inputColor};
    --colors-input-placeholder-color: ${theme.palette.inputPlaceholderColor};
    --colors-error: ${theme.palette.errorColor};
  }
`;

export default ROOT_VARIABLES;
